import { RemoveUndefined } from './tsUtilityTypes';

export const removeUndefined = <T extends Record<string, unknown>>(
  obj: T
): RemoveUndefined<{
  [K in keyof T as T[K] extends undefined ? never : K]: T[K];
}> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as RemoveUndefined<T>;
};

export const emptyObject = {};

export function keys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}

export const valueOrFallback = <T>(newValue: T, oldValue: T | undefined): T | undefined => {
  return !newValue ? oldValue : newValue;
};

export const stringifyBigInt = (value: Record<PropertyKey, unknown>, pretty = true) => {
  const seen = new WeakSet();
  try {
    return JSON.stringify(
      value,
      (_key, v) => {
        if (typeof v === 'object' && v !== null) {
          if (seen.has(v)) {
            return '[Circular Reference]';
          }
          seen.add(v);
        }
        return typeof v === 'bigint' ? v.toString() : v;
      },
      pretty ? 2 : undefined
    );
  } catch (_err) {
    console.error('Error stringify object error:', _err);
    return `[Could not stringify object]`;
  }
};

export const isEmptyObject = (obj: unknown) => {
  if (typeof obj !== 'object') {
    return false;
  }
  if (obj === null) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const omit = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  key: K
): Omit<T, K> => {
  const { [key]: _, ...rest } = obj;
  return rest;
};
